module.exports = __webpack_public_path__ + "media/images/badge-nomad@2x-c70ffa2081e9900406ce514f95722277.png";